import React, { useCallback, useState } from "react";
import keycloak from "../keycloak";
const useHttp = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);

    const get_token = () => {
        let token = "";
        if (sessionStorage.getItem("user") != "" && sessionStorage.getItem("user") != null) {
            token = JSON.parse(sessionStorage.user).token;
            // console.log(token);
        }
        return token;
    }


    /* function for retriving data*/
    const sendReq = useCallback(async (reqConfig, appyData) => {
        // console.log("fetching");
        setIsLoading(true);
        setError(null);
        let token = get_token();
        try {
            const responce = await fetch(reqConfig.url,
                {
                    method: 'POST',
                    body: JSON.stringify(reqConfig.body),
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                        'x-auth-token': token
                    }
                }
            );

            if (!responce.ok) {
                if (responce.status === 401) {
                    sessionStorage.removeItem("user");
                    // window.location.href = "/login";
                    // keycloak.logout({
                    //     redirectUri: window.location.origin
                    // })
                    window.location.href = "/";
                    return;
                }

                if (responce.status === 429) {
                    throw new Error("Too many requests, please try after some time");
                }
                if (responce.status === 403) {
                    sessionStorage.removeItem("user");
                    // window.location.href = "/login";
                    keycloak.logout({
                        redirectUri: window.location.origin
                    })
                    throw new Error("Invalid User Id / Password");
                }

                const errorMessage = "Something went wrong";
                throw new Error(errorMessage);
            }

            const result = await responce.json()
            appyData(result);

        } catch (err) {
            setError(err.message || "Something Failed");
        }
        setIsLoading(false);
    }, []);

    const sendReq2 = useCallback(async (reqConfig, appyData) => {
        // console.log("fetching");
        setIsLoading(true);
        setError(null);
        let token = get_token();
        try {
            const responce = await fetch(reqConfig.url,
                {
                    method: 'POST',
                    body: reqConfig.body,
                    headers: {
                        // 'Content-type': 'application/json; charset=UTF-8',
                        'x-auth-token': token
                    }
                }
            );

            if (!responce.ok) {
                if (responce.status === 401) {
                    sessionStorage.removeItem("user");
                    // window.location.href = "/login";
                    window.location.href = "/";
                    return;
                }

                if (responce.status === 429) {
                    throw new Error("Too many requests, please try after some time");
                }
                if (responce.status === 403) {
                    throw new Error("Invalid User Id / Password");
                }

                const errorMessage = "Something went wrong";
                throw new Error(errorMessage);
            }

            const result = await responce.json()
            appyData(result);

        } catch (err) {
            setError(err.message || "Something Failed");
        }
        setIsLoading(false);
    }, []);

    return {
        isLoading,
        error,
        sendReq,
        sendReq2
    }
}

export default useHttp;